{
  "all": "Wszystkie",
  "choose": "Wybierz",
  "notFound": "Nie znaleziono danych",
  "orderService": {
    "CLIENT": "Klient",
    "BANK": "Bank",
    "COMPLETED": "Zakończona",
    "INACTIVE": "Nieaktywne",
    "EXPIRED": "Wygasłe"
  },
  "orderStatus": {
    "DRAFT": "W edycji",
    "REJECTED": "Odrzucone",
    "COMPLETED": "Zrealizowane",
    "EXPIRED": "Wygasłe",
    "CANCELLED": "Anulowane",
    "READY_TO_COMPLETE": "Oczekuje na realizację",
    "VERIFICATION": "Weryfikacja w banku",
    "VERIFIED": "Zweryfikowane",
    "SIGNING": "Oczekuje na podpis",
    "WAITING_FOR_PRINT_ACCEPT": "Oczekuje na akceptację"
  },
  "orderType": {
    "OWN": "Gwarancja nostro",
    "FOREIGN": "Gwarancja loro",
    "ANNEX": "Aneks",
    "GUARANTEE_MODIFICATION": "Modyfikacja gwarancji"
  },
  "orderSafeguard": {
    "CONTRACT": "Umowy o udzielenie gwarancji",
    "SINGLE_PURPOSE_CREDIT_LINE": "Linii gwarancji",
    "MULTI_PURPOSE_CREDIT_LINE": "Umowy o finansowanie wielocelowe",
    "GLOBAL_LIMIT_CREDIT_LINE": "Limitu globalnego"
  },
  "originTypes": {
    "BANK": "Bank",
    "CLIENT": "Klient"
  },
  "creator": {
    "BANK": "Bank",
    "CLIENT": "Klient"
  },
  "notificationCode": {
    "OPERATOR_ASSIGNED": "Przypisanie operatora",
    "ORDER_STATUS_VERIFIED": "Zweryfikowano",
    "ORDER_TO_SIGN": "Oczekuje na podpis",
    "ORDER_STATUS_READY_TO_COMPLETE": "Przesłano do realizacji",
    "ORDER_STATUS_WAITING_TO_BE_COMPLETED": "Oczekuje na akceptację",
    "ORDER_STATUS_REJECTED": "Odrzucone",
    "ORDER_STATUS_COMPLETED": "Zrealizowane",
    "OPERATOR_CHANGED": "Zmiana przypisanego operatora"
  },
  "voivodeship": {
    "DOLNOSLASKIE": "dolnośląskie",
    "KUJAWSKOPOMORSKIE": "kujawsko-pomorskie",
    "LUBELSKIE": "lubelskie",
    "LUBUSKIE": "lubuskie",
    "LODZKIE": "łódzkie",
    "MALOPOLSKIE": "małopolskie",
    "MAZOWIECKIE": "mazowieckie",
    "OPOLSKIE": "opolskie",
    "PODKARPACKIE": "podkarpackie",
    "PODLASKIE": "podlaskie",
    "POMORSKIE": "pomorskie",
    "SLASKIE": "śląskie",
    "SWIETOKRZYSKIE": "świętokrzyskie",
    "WARMINSKOMAZURSKIE": "warmińsko-mazurskie",
    "WIELKOPOLSKIE": "wielkopolskie",
    "ZACHODNIOPOMORSKIE": "zachodniopomorskie"
  },
  "boolean": {
    "true": "Tak",
    "false": "Nie"
  }
}
